const list = [
    {
        'text': 'Employee-Self-Paying',
        'value': 2
    },
    {
        'value': 1,
        'text': 'Employer-Sponsored'
    }
];

export default list;

export function isCompanySponsoredType (companyType) {
    return companyType === 1;
}

export function getCompanyTypeByValue (companyType) {
    return list.find(t => t.value === companyType);
}
